import React, { useState, useEffect } from "react";
import { Layout, Menu, Grid } from "antd";
import { LogoutOutlined, UnorderedListOutlined } from "@ant-design/icons";
import {
  useTranslate,
  useLogout,
  CanAccess,
  ITreeMenu,
  useIsExistAuthentication,
  useRouterContext,
  useMenu,
} from "@pankod/refine-core";
import logo from "assets/img/GLlogo.png";
import { css } from "@emotion/react";

import { antLayoutSider, antLayoutSiderMobile } from "./styles";
import { RefineLayoutSiderProps } from "@pankod/refine-ui-types";
import { useMe } from "context/MeContext";
import { useNavigate } from "react-router-dom";
const { SubMenu } = Menu;

export const Sider: React.FC<RefineLayoutSiderProps> = ({ render }) => {

  const { isSuperAdmin } = useMe();
  const [collapsed, setCollapsed] = useState<boolean>(false);
  const isExistAuthentication = useIsExistAuthentication();
  const { Link, useHistory } = useRouterContext();
  const history = useHistory();

  const { mutate: mutateLogout } = useLogout();
  const translate = useTranslate();
  const { menuItems, selectedKey, defaultOpenKeys } = useMenu();
  const breakpoint = Grid.useBreakpoint();

  const isMobile = typeof breakpoint.lg === "undefined" ? false : !breakpoint.lg;

  const hiddenForRegularAdmins = [
    "Employer",     
    "Question",     
    "Dimension",      
    "white-email",
    "Resources"    
  ];

  const filterMenuItems = (items: ITreeMenu[]): ITreeMenu[] => {
    if (!items || items.length === 0) return [];
    
    return items.map(item => {
      const newItem = { ...item };
      
      if (newItem.children && newItem.children.length > 0) {
        newItem.children = filterMenuItems(newItem.children);
      }
      
      return newItem;
    }).filter(item => {
      if (isSuperAdmin) return true;
      return !hiddenForRegularAdmins.includes(item.name);
    });
  };

  const _menuItems = filterMenuItems(menuItems);
  
  //console.log("Filtered menu items:", _menuItems);

  const renderTreeView = (tree: ITreeMenu[], selectedKey: string) => {
    return tree.map((item: ITreeMenu) => {
      const { icon, label, route, name, children, parentName, key } = item;
      const isSelected1 = name === selectedKey;
      if (children.length > 0) {
        return (
          <CanAccess
            key={name}
            resource={name.toLowerCase()}
            action="list"
            params={{
              resource: item,
            }}  
          >
            <SubMenu
              key={name}
              title={label}
              icon={icon}
              onTitleClick={() => {
                if (route) {
                  history.push(route);
                }
              }}
            >
              {!collapsed && renderTreeView(children, selectedKey)}
            </SubMenu>
          </CanAccess>
        );
      }
      const isSelected = route === selectedKey;
      const isRoute = !(parentName !== undefined && children.length === 0);
      
      return (
        <CanAccess
          key={route}
          resource={name.toLowerCase()}
          action="list"
          params={{
            resource: item,
          }}
        >
          <Menu.Item
            key={route}
            style={{
              //fontWeight: isSelected ? "bold" : "normal",
              backgroundColor: isSelected ? "whitesmoke" : "",
            }}
          >
            <Link to={route}
              style={{
                fontWeight: isSelected ? "500" : "400",
                color: isSelected ? "#16628b" : "rgb(4, 6, 10, 0.5)",
              }}
            >{label}</Link>
            {!collapsed && isSelected && <div className="ant-menu-tree-arrow" />}
          </Menu.Item>
        </CanAccess>
      );
    });
  };

  const logout = isExistAuthentication && (
    <Menu.Item key="logout" onClick={() => mutateLogout()} icon={<LogoutOutlined />}>
      {translate("buttons.logout", "Logout")}
    </Menu.Item>
  );

  const dashboard = null;
  const items = renderTreeView(_menuItems, selectedKey);

  const renderSider = () => {
    if (render) {
      return render({
        dashboard,
        items,
        logout,
        collapsed,
      });
    }
    return (
      <>
        {dashboard}
        {items}
        {/* {logout} */}
      </>
    );
  };

  return (
    <Layout.Sider
      css={css`
        background: white !important;
        span {
          // padding-left: 0px;
          font-weight: 400;
        }
        .logo {
          width: 70%;
          margin: auto;
          padding: 10px 0;
        }
        .ant-menu-light.ant-menu-root.ant-menu-inline {
          border-inline-end: none !important;
        }
        border-right: 1px solid rgba(124, 124, 124, 0.4);
        .ant-menu-submenu-title {
          color:rgba(4, 6, 10, 0.5) !important;
        }
        .sub-item {
          margin-left: 20px;
          width: 100%;
        }
      `}
      breakpoint="lg"
      style={isMobile ? antLayoutSiderMobile : antLayoutSider}
    >
      <div className="logo">
        <img src={logo} alt="Monument Health logo"/>
      </div>
      <Menu
        selectedKeys={[selectedKey]}
        defaultOpenKeys={["admin","forum","MainMenu","MenuCore","MenuContent","MenuSystem","MenuChat"]}
        mode="inline"
        onClick={() => {
          if (!breakpoint.lg) {
            setCollapsed(true);
          }
        }}
      >
        {renderSider()}
      </Menu>
    </Layout.Sider>
  );
};